import React, { useState } from "react";
import smartDealGraphIcon from "../../../../assets/inventory/smart-deal-graph.svg";
import { Button, Col, Row } from "reactstrap";
import closeIcon from "../../../../assets/icon/chatClose.svg";
import InvOptimizationLocateProduct from "../InvOptimizationLocateProduct";
import InvSmartDealIcon from "../../../../assets/icon/inv-smart-deal.svg";
import doubleArrow from "../../../../assets/icon/double-arrow-down.svg";

const InvOptimizationSmartDeal = ({ closeModal }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [showImg, setShowImg] = useState(true);
  const [showRecommended, setShowRecommended] = useState(true);

  return (
    <div>
      <div className="smart-opt-inv p-3 pt-2">
        <div className="optsnap-deal-cards" style={{ width: "81vw" }}>
          <div
            style={{
              paddingBottom: "8px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
              Current Product{" "}
              <span
                className="cursor-pointer"
                onClick={() => setShowImg(!showImg)}
              >
                {showImg ? (
                  <img
                    src={doubleArrow}
                    style={{
                      transform: "rotate(180deg)",
                      transition: "opacity 0.3s ease, transform 0.3s ease",
                      marginLeft:"12px"
                    }}
                  />
                ) : (
                  <img
                    src={doubleArrow}
                    style={{ transition: "opacity 0.3s ease",
                         marginLeft:"12px",verticalAlign:"middle"
                     }}
                  />
                )}
              </span>
            </div>
            <Button color="primary" onClick={() => setModalOpen(true)}>
              Locate Product
            </Button>
          </div>
          <div className="section-devider-border-popup m-0"></div>
          <div className="inv-smartdeal-img">
            {showImg ? (
              <img
                style={{ width: "100%" }}
                src={InvSmartDealIcon}
                alt="not available"
              />
            ) : (
              <></>
            )}
          </div>
          <Row>
            <Col>
              <div className="inv-pdetails">Drug Name</div>
              <div className="sanp-drug-data">Lisinopril 10 MG Tablet</div>
            </Col>
            <Col>
              <div className="inv-pdetails">NDC</div>
              <div className="sanp-drug-data">68190-0513-01</div>
            </Col>
            <Col>
              <div className="inv-pdetails">Manufacturer</div>
              <div className="sanp-drug-data">Lupin Pharmacuticals</div>
            </Col>
            <Col>
              <div className="inv-pdetails">NDC</div>
              <div className="sanp-drug-data">McKesson</div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="inv-pdetails">Package Price</div>
              <div className="sanp-drug-data">$ 89.50</div>
            </Col>
            <Col>
              <div className="inv-pdetails">Annual Usage</div>
              <div className="sanp-drug-data">48,000 Tablets</div>
            </Col>
            <Col>
              <div className="inv-pdetails">Annual Spend</div>
              <div className="sanp-drug-data">$ 4,296.00</div>
            </Col>
            <Col>
              <div className="inv-pdetails">Current On Hand</div>
              <div className="sanp-drug-data">1,398</div>
            </Col>
          </Row>
          <Row>
            <Col lg={3}>
              <div className="inv-pdetails">Par Level</div>
              <div className="sanp-drug-data">4000</div>
            </Col>
            <Col lg={4}>
              <div className="inv-pdetails">Last Ordered</div>
              <div className="sanp-drug-data">12/15/2024</div>
            </Col>
          </Row>
        </div>
      </div>
      <div className="smart-opt-inv p-3 pt-2">
        <div className="optsnap-deal-cards" style={{ width: "81vw", backgroundColor:"#DBCAD8" }}>
          <div
            style={{
              paddingBottom: showRecommended ? "8px" : "",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
              Recommended Product Details{" "}
              <span
                className="cursor-pointer"
                onClick={() => setShowRecommended(!showRecommended)}
              >
                {showRecommended ? (
                  <img
                    src={doubleArrow}
                    style={{
                      transform: "rotate(180deg)",
                      transition: "opacity 0.3s ease, transform 0.3s ease",
                    }}
                  />
                ) : (
                  <img
                    src={doubleArrow}
                    style={{ transition: "opacity 0.3s ease" }}
                  />
                )}
              </span>
            </div>
          </div>
          {showRecommended ? (
            <>
              <div className="inv-section-devider-border-popup"></div>
              <Row>
                <Col>
                  <div className="inv-pdetails">Drug Name</div>
                  <div className="sanp-drug-data">Lisinopril 10 MG Tablet</div>
                </Col>
                <Col>
                  <div className="inv-pdetails">NDC</div>
                  <div className="sanp-drug-data">68190-0513-01</div>
                </Col>
                <Col>
                  <div className="inv-pdetails">Manufacturer</div>
                  <div className="sanp-drug-data">Alembic Pharmacuticals</div>
                </Col>
                <Col>
                  <div className="inv-pdetails">Manufacturer</div>
                  <div className="sanp-drug-data">Anda</div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="inv-pdetails">Package Price</div>
                  <div className="sanp-drug-data">$ 36.50</div>
                </Col>
                <Col>
                  <div className="inv-pdetails">Projected Usage</div>
                  <div className="sanp-drug-data">48,000 Tablets</div>
                </Col>
                <Col>
                  <div className="inv-pdetails">Projected Spend</div>
                  <div className="sanp-drug-data">$ 1,752.00</div>
                </Col>
                <Col>
                  <div className="inv-pdetails">Substitution</div>
                  <div className="sanp-drug-data">AB Rated</div>
                </Col>
              </Row>
              <Row>
                <Col lg={3}>
                  <div className="inv-pdetails">Contract</div>
                  <div className="sanp-drug-data">N/A</div>
                </Col>
                <Col lg={4}>
                  <div className="inv-pdetails">Availability</div>
                  <div className="sanp-drug-data">In Stock</div>
                </Col>
              </Row>
            </>
          ) : (
            <></>
          )}
        </div>
      </div>
      {modalOpen && (
        <div className="smart-deal-backdrop">
          <InvOptimizationLocateProduct
            closeButton={() => setModalOpen(false)}
          />
        </div>
      )}
    </div>
  );
};

export default InvOptimizationSmartDeal;
